<template>
  <v-app>

    <v-app-bar app color="primary" dark >
      <div v-if="!tabletScreen" class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />
        <div contain min-width="210" width="210">Fernando Retuerta Blázquez</div>
      </div>
      <v-spacer></v-spacer>
      <div>Curriculum Vitae</div>
      <v-spacer></v-spacer>
      <v-btn text @click="toogleLang(langToChange)">
        <span v-if="!mobileScreen" class="mr-2">{{ $t('menu.changeTo') }}</span>
        <img class="flag" :src="'/resources/flags/' + langToChange + '.svg'">
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-toolbar fixed style="position:fixed;width:100%;z-index:3" dstyle="xtop:toolbarHeight + 'px'}">
        <div class="menu">
          <router-link v-for="menuOption in menuOptions" :key="menuOption.option" :to="'/' + menuOption.option" class="menuOption">
            <v-btn dark><v-icon left>{{ menuOption.icon }}</v-icon><span v-if="!tabletScreen">{{ $t('menu.' + menuOption.option) }}</span></v-btn>
          </router-link>
        </div>
      </v-toolbar>
      <div class="content">
        <router-view></router-view>
      </div>
    </v-main>

    <v-footer>
      <v-spacer></v-spacer>
      <div>Fernando Retuerta Blázquez &copy; 2026</div>
    </v-footer>

  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    langToChange: 'es',
    mobileScreen: false,
    tabletScreen: false,
    menuOptions: [
      { option: 'presentation', icon: 'contacts'},
      { option: 'formation', icon: 'school' },
      { option: 'experience', icon: 'work' },
      { option: 'knowledge', icon: 'engineering' },
      { option: 'contact', icon: 'call' },
    ]
  }),
  methods: {
    toogleLang(lang) {
      this.$i18n.locale = lang
      if (lang == 'es') { this.langToChange = 'en' }
      if (lang == 'en') { this.langToChange = 'es' }
    },
    onResize() {
      this.mobileScreen = window.innerWidth < 480 // 320
      this.tabletScreen = window.innerWidth < 935
    },
  },
  created() {
    if (this.$i18n.locale = 'es') this.langToChange = 'en'
    else this.langToChange = 'es'
  
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
};
</script>

<style scoped lang="scss">

  .flag {
    width: 50px;
  }

  .menu {
    padding: 1.5rem;
    .menuOption {
      text-decoration: none;
      .v-btn {
        background-color: #1976d2;
      }
    }
    .menuOption.router-link-active {
      .v-btn {
        background-color: #0d3a66;
      }
    }
  }

  @media (max-width: 435px) {
    .menu {
      padding: 0;
      .menuOption {
        .v-btn {
          min-width: 50px;
        }
      }
    }
  }

  .v-main {
    background-color: gainsboro;
  }

  .content {
    margin-top: 3.5rem;
    padding: 1rem;
  }

  a {
    margin: 2px;
  }

  .v-footer {
    background-color: #1976d2 !important;
    color: #FFFFFF !important;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 3;
  }
</style>
